<template>
  <div class="is-pulled-right review-actions">
    <button
      v-if="result.isNotOK()"
      @click="$emit('showFinding', result)"
      class="button is-outlined radius-circle"
      :class="[ result.finding.hasAnsweredFinding() ? 'is-info' : 'is-danger' ]">
        <span class="icon is-medium">
          <i class="mdi mdi-exclamation check-icon"></i>
        </span>
    </button>
    <button
      @click="$emit('openCommentSection', result)"
      class="button is-outlined radius-circle is-gray">
      <span class="icon is-medium">
        <i v-if="result.comments.length" class="mdi mdi-comment-text-outline check-icon"></i>
        <i v-else class="mdi mdi-comment-outline check-icon"></i>
      </span>
    </button>
  </div>
</template>

<script>
  import { ReviewResult } from '@/classes/case/ReviewResult'

  export default {
    name: 'report-actions-component',
    props: {
      result: {
        type: ReviewResult,
        required: true
      }
    }
  }
</script>

<style lang="sass" scoped>
  .check-icon
    font-size: 1.3em !important
</style>
